import { render, staticRenderFns } from "./shopWalletList.vue?vue&type=template&id=330519fe&scoped=true&"
import script from "./shopWalletList.vue?vue&type=script&lang=js&"
export * from "./shopWalletList.vue?vue&type=script&lang=js&"
import style0 from "./shopWalletList.vue?vue&type=style&index=0&id=330519fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330519fe",
  null
  
)

export default component.exports